import globalApi from '../../api'

// mem
// export const getIntervenorListApi = ({ take, skip }) =>
//   globalApi.post('/Account/getIntervenorList', {
//     take,
//     skip,
//     isSecured: true,
//   })

export const getIntervenorListApi = ({ filter }) =>
  globalApi.post('/Account/getIntervenorList', { ...filter, isSecured: true})

// mem
export const createIntervenorApi = ({
  email,
  entityType,
  entityName,
  wilayaId,
  dairaId,
  communeId,
  phoneNumber,
  contactEmail,
  contactPhoneNumber,
}) =>
  globalApi.post('/Account/createIntervenor', {
    email,
    entityType,
    entityName,
    wilayaId,
    dairaId,
    communeId,
    // mem
    phoneNumber,
    contactEmail,
    contactPhoneNumber,
    isSecured: true,
  })

export const deleteIntervenorApi = ({ email }) =>
  globalApi.post('/Account/deleteIntervenor', {
    email,
    isSecured: true,
  })

export const banIntervenorApi = ({ email }) =>
  globalApi.post('/Account/banIntervenor', {
    email,
    isSecured: true,
  })

export const unbanIntervenorApi = ({ email }) =>
  globalApi.post('/Account/unbanIntervenor', {
    email,
    isSecured: true,
  })

//
export const getApiWilayasIPA = () =>
  globalApi.get('/Zones/Wilayas', {
    isSecured: true,
  })

//
export const getDairasOfWilayasApi = (id) =>
  globalApi.get(`/Zones/DairasOfWilaya/${id}`, {
    isSecured: true,
  })

//
export const getCommunesOfDairasApi = (id) =>
  globalApi.get(`/Zones/CommunesOfDaira/${id}`, {
    isSecured: true,
  })

//
export const getApiDairaName = (id) =>
  globalApi.post('/Zones/Dairas', {
    dairaIds: id, // mem
    isSecured: true,
  })

// mem
export const getApiWilayaName = (id) =>
  globalApi.post('/Zones/Wilayas', {
    wilayaIds: id, // mem
    isSecured: true,
  })

// mem
export const getApiCommuneName = (id) =>
  globalApi.post('/Zones/Communes', {
    communeIds: id, // mem
    isSecured: true,
  })
// thr
export const uploadIntervenorsFileApi = (formData, userEntityType) =>
  globalApi.post(
    '/Account/createIntervenorsFromFile',
    formData,
    { params: { userEntityType: userEntityType } },
    { isSecured: true },
  )
// thr
export const editIntervenorApi = ({
  email,
  entityType,
  entityName,
  wilayaId,
  dairaId,
  communeId,
  phoneNumber,
  contactEmail,
  contactPhoneNumber,
}) =>
  globalApi.post('/Account/editIntervenor', {
    email,
    entityType,
    entityName,
    wilayaId,
    dairaId,
    communeId,
    phoneNumber,
    contactEmail,
    contactPhoneNumber,
    isSecured: true,
  })

// export const FilterIntervenantApi = ({ email }) =>
//   globalApi.post('/Account/searchIntervenors', {
//     email,
//     isSecured: true,
//   })